import { lazy } from 'react';
import ServiceInquiry from '../PAGES/USERDOJANG/SERVICE/Inquiry/ServiceInquiry';

const AppNoteList = lazy(() => import('../PAGES/USERDOJANG/APP/NOTE/LIST/AppNoteList'));
const AppNoticeList = lazy(() => import('../PAGES/USERDOJANG/APP/NOTICE/LIST/AppNoticeList'));
const AppScheduleList = lazy(() => import('../PAGES/USERDOJANG/APP/SCHEDULE/LIST/AppScheduleList'));
const AttendanceRegist = lazy(
  () => import('../PAGES/USERDOJANG/ATTENDANCE/REGIST/AttendanceRegist'),
);
const AttendanceStatus = lazy(
  () => import('../PAGES/USERDOJANG/ATTENDANCE/STATUS/AttendanceStatus'),
);
const BillManagement = lazy(() => import('../PAGES/USERDOJANG/BILL/MANAGEMENT/BillManagement'));
const BillRead = lazy(() => import('../PAGES/USERDOJANG/BILL/READ/BillRead'));
const BillSend = lazy(() => import('../PAGES/USERDOJANG/BILL/SEND/BillSend'));
const BillSettings = lazy(() => import('../PAGES/USERDOJANG/BILL/SETTINGS/BillSettings'));
const DashBoard = lazy(() => import('../PAGES/USERDOJANG/DASHBOARD/DashBoard'));
const DojangList = lazy(() => import('../PAGES/USERDOJANG/DOJANG/LIST/DojangList'));
const DojangRegist = lazy(() => import('../PAGES/USERDOJANG/DOJANG/REGIST/DojangRegist'));
const DojangSelect = lazy(() => import('../PAGES/USERDOJANG/DOJANG/SELECT/DojangSelect'));
const FitnessList = lazy(() => import('../PAGES/USERDOJANG/FITNESS/LIST/FitnessList'));
const FitnessManagement = lazy(
  () => import('../PAGES/USERDOJANG/FITNESS/MANAGEMENT/FitnessManagement'),
);
const FitnessRegist = lazy(() => import('../PAGES/USERDOJANG/FITNESS/REGIST/FitnessRegist'));
const HealthcareList = lazy(() => import('../PAGES/USERDOJANG/HEALTHCARE/LIST/HealthcareList'));
const DojangHome = lazy(() => import('../PAGES/USERDOJANG/HOME/DojangHome'));
const DojangHomepage = lazy(() => import('../PAGES/USERDOJANG/HOMEPAGE/DojangHomepage'));
const InvitationInquiry = lazy(
  () => import('../PAGES/USERDOJANG/INVITATION/INQUIRY/InvitationInquiry'),
);
const InvitationSend = lazy(() => import('../PAGES/USERDOJANG/INVITATION/SEND/InvitationSend'));
const InvitaionSendStudent = lazy(
  () => import('../PAGES/USERDOJANG/INVITATION/SEND/STUDENT/InvitaionSendStudent'),
);
const InvitaionSendStudentTransmission = lazy(
  () =>
    import(
      '../PAGES/USERDOJANG/INVITATION/SEND/STUDENT/TRANSMISSION/InvitaionSendStudentTransmission'
    ),
);
const InvitationSendTeacher = lazy(
  () => import('../PAGES/USERDOJANG/INVITATION/SEND/TEACHER/InvitationSendTeacher'),
);
const LevelupHistory = lazy(() => import('../PAGES/USERDOJANG/LEVELUP/HISTORY/LevelupHistory'));
const LevelupRegist = lazy(() => import('../PAGES/USERDOJANG/LEVELUP/REGIST/LevelupRegist'));
const LevelupRegistSelect = lazy(
  () => import('../PAGES/USERDOJANG/LEVELUP/REGIST/SELECT/LevelupRegistSelect'),
);
const ManageBusList = lazy(() => import('../PAGES/USERDOJANG/MANAGE/BUS/LIST/ManageBusList'));
const ManageClassList = lazy(() => import('../PAGES/USERDOJANG/MANAGE/CLASS/LIST/ManageClassList'));
const ManageDojang = lazy(() => import('../PAGES/USERDOJANG/MANAGE/DOJANG/ManageDojang'));
const ManageLevelSystem = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/LEVELSYSTEM/ManageLevelSystem'),
);
const ManageLevelSystemRegist = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/LEVELSYSTEM/REGIST/ManageLevelSystemRegist'),
);
const ManageSabumDetail = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/SABUM/DETAIL/ManageSabumDetail'),
);
const ManageSabumList = lazy(() => import('../PAGES/USERDOJANG/MANAGE/SABUM/LIST/ManageSabumList'));
const StudentRegistLump = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/backup/StudentRegistLump'),
);
const ManageStudentBulkEdit = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/Bulk/ManageStudentBulkEdit'),
);
const ManageStudentDetail = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/DETAIL/ManageStudentDetail'),
);
const ManageStudentList = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/LIST/ManageStudentList'),
);
const StudentRegistExist = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/REGIST/EXIST/StudentRegistExist'),
);
const ManageStudentRegist = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/REGIST/ManageStudentRegist'),
);
const StudentRegistNew = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/REGIST/NEW/StudentRegistNew'),
);
const ManageStudentRestList = lazy(
  () => import('../PAGES/USERDOJANG/MANAGE/STUDENT/REST/LIST/ManageStudentRestList'),
);
const MypageAccount = lazy(() => import('../PAGES/USERDOJANG/MYPAGE/ACCOUNT/MypageAccount'));
const MypageResume = lazy(() => import('../PAGES/USERDOJANG/MYPAGE/RESUME/MypageResume'));
const MyPageSelectInvitation = lazy(
  () => import('../PAGES/USERDOJANG/MYPAGE/SELECTINVITATION/MypageSelectInvitation'),
);
const ServicePgSign = lazy(() => import('../PAGES/USERDOJANG/SERVICE/PG/ServicePgSign'));
const PgSignComponent = lazy(() => import('../PAGES/USERDOJANG/SERVICE/PGForm/PgSignComponent'));

// routes
const dojangRoutes = {
  common: [
    // root
    { path: '/home', element: <DojangHome /> },
    { path: '/dashboard', element: <DashBoard /> },
    // dojang
    { path: '/manage/dojang', element: <ManageDojang /> },
    // invitation
    { path: '/invitation/send', element: <InvitationSend /> },
    { path: '/invitation/send/student', element: <InvitaionSendStudent /> },
    {
      path: '/invitation/send/student/transmission',
      element: <InvitaionSendStudentTransmission />,
    },
    { path: '/invitation/send/teacher', element: <InvitationSendTeacher /> },
    { path: '/invitation/inquiry', element: <InvitationInquiry /> },
    // class
    { path: '/manage/class/list', element: <ManageClassList /> },
    // bus
    { path: '/manage/bus', element: <ManageBusList /> },
    // student
    { path: '/manage/student/list', element: <ManageStudentList /> },
    { path: '/manage/student/rest/list', element: <ManageStudentRestList /> },
    { path: '/manage/student/detail', element: <ManageStudentDetail /> },
    { path: '/manage/student/regist', element: <ManageStudentRegist /> },
    { path: '/manage/student/regist/new', element: <StudentRegistNew /> },
    { path: '/manage/student/regist/exist', element: <StudentRegistExist /> },
    { path: '/manage/student/regist/lump', element: <StudentRegistLump /> },
    { path: 'manage/student/regist/bulk', element: <ManageStudentBulkEdit /> },
    // attendance
    { path: '/attendance/regist', element: <AttendanceRegist /> },
    { path: '/attendance/status', element: <AttendanceStatus /> },
    // level
    { path: '/manage/levelsystem', element: <ManageLevelSystem /> },
    { path: '/manage/levelsystem/regist', element: <ManageLevelSystemRegist /> },
    // levelup
    { path: '/levelup/history', element: <LevelupHistory /> },
    // fitness
    { path: '/fitness/list', element: <FitnessList /> },
    { path: '/fitness/regist', element: <FitnessRegist /> },
    { path: '/fitness/management', element: <FitnessManagement /> },
    // app
    { path: '/app/notice/list', element: <AppNoticeList /> },
    { path: '/app/note/list', element: <AppNoteList /> },
    { path: '/app/schedule/list', element: <AppScheduleList /> },
    // homepage
    { path: '/hp', element: <DojangHomepage /> },
    // payment
    { path: '/service/pg/intro', element: <ServicePgSign /> },
    { path: '/service/pg/signForm', element: <PgSignComponent /> },
    { path: '/service/inquiry', element: <ServiceInquiry /> },

    // mypage
    { path: '/mypage/account', element: <MypageAccount /> },
    { path: '/mypage/resume', element: <MypageResume /> },
    { path: '', element: <DojangHome /> },
    { path: '', element: <DojangHome /> },
    { path: '', element: <DojangHome /> },
  ],
  joinedHC: [
    // health care
    { path: '/healthcare/list', element: <HealthcareList /> },
  ],
  joinedPG: [
    // bill
    { path: '/bill/read', element: <BillRead /> },
    { path: '/bill/send', element: <BillSend /> },
  ],
  unselectedDojang: [
    // invitation
    { path: '/mypage/selectinvitation', element: <MyPageSelectInvitation /> },
    // dojangs
    { path: '/dojang/select', element: <DojangSelect /> },
    { path: '/dojang/list', element: <DojangList /> },
  ],
  unselectedDojangOnlyKW: [
    // dojang
    { path: '/dojang/regist', element: <DojangRegist /> },
  ],
  onlyKW: [
    // sabum
    { path: '/manage/sabum/list', element: <ManageSabumList /> },
    { path: '/manage/sabum/detail', element: <ManageSabumDetail /> },
    // bill
    { path: '/bill/management', element: <BillManagement /> },
    { path: '/bill/settings', element: <BillSettings /> },
    // levelup
    { path: '/levelup/regist', element: <LevelupRegist /> },
    { path: '/levelup/regist/select', element: <LevelupRegistSelect /> },
  ],
  onlySA: [
    // account
    { path: '/account/myinfo', element: <MypageAccount /> },
    { path: '/account/resume', element: <MypageResume /> },
  ],
};

export default dojangRoutes;
